jQuery( document ).ready( function( $ ) {
    // Make sort by selector go to tag page
    $( '.collectionGrid__sorting select' ).on( 'change', function() {
      var sortByUrl = $( this ).val();
  
      window.location = window.location.pathname + '?sort_by=' + sortByUrl;
    });

    function preloadImage(url) {
        if (url) {
            var img = new Image();
            img.src = url;

            img.onload = function() {
                console.log('Image loaded: ' + url);
            };
            img.onerror = function() {
                console.log('Image failed to load: ' + url);
            };
        }
    }

    $('.colorCircle--clickable').each(function(){
        var imgUrl = $(this).attr('data-variant-image');
        preloadImage(imgUrl);
    });


    $('.colorCircle--clickable').on('click', function() {
        var imgTarget = $(this).closest('.collectionCard').find('.collectionCard__image');
        imgTarget.attr('src', $(this).attr('data-variant-image'));
    });
  });